<form [formGroup]="formGroup" class="w-full h-full p-5 bg-lightCardBG dark:bg-darkCardBG text-lightMode-700 dark:text-darkMode-200" [class]="isDesktop()?'relative':'w-screen fixed left-0 top-0'">
    <button matRipple (click)="exit()" class="absolute left-5 top-2 w-8 h-8 rounded-full overflow-hidden mat-center z-30">
        <mat-icon class="mat-center">
            close
        </mat-icon>
    </button>
    <div class="my-1 w-full text-center text-inherit">
        {{name}}
    </div>
    <div class="w-full mb-3 text-inherit">
        <label for="field" class="text-lg py-2 px-3 mb-2">
            نام شهر*
        </label>
        <app-search-select [type]="'city'" (emitId)="updateCity($event)" [layer]="data.layer" class="w-full"></app-search-select>
    </div>
    <div class="w-full my-3">
        <label for="center-logo" class="text-lg py-2 px-3 whitespace-nowrap">
            تصویر*
        </label>
        <br>
        <label class="w-full flex justify-center mt-2">
            <div *ngIf="!(getImage()|async)" class="w-1/2 aspect-square">
                <mat-icon aria-hidden="true" data-mat-icon-type="font"  matRipple class="cursor-pointer mat-center hover:opacity-80 mat-full-center text-[9rem]">
                    add_photo_alternate
                </mat-icon>
            </div>
            <img *ngIf="(getImage()|async) as inputedImage" [src]="inputedImage" class="w-1/2 rounded-md">
            <input type="file" accept=".webp, .png, Png, PNG, .jpeg, .jpg, .JPG, JPEG, Jpeg|image/*" (change)="onFileChange($event)" class="py-2 px-4 bg-transparent text-inherit hidden">
            <input type="hidden" name="fileHidden" formControlName="image"/>
            <!-- <input id="center-logo" name="center-logo" type="file" (change)="onFileChange($event)" class="hidden"> -->
        </label>
    </div>
    <div class="w-full flex justify-center">
        <button [mat-dialog-close]="getFormData()" (click)="done()" class="blueButton mt-2 w-full" [class]="getFormData()?'opacity-100':'opacity-30'">
            افزودن
        </button>
    </div>
</form>